import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@core/auth/AuthProvider";
import { OrganizationProvider } from "@core/organizations/OrganizationProvider";
import { AppPreferencesProvider } from "@core/preferences/AppPreferencesProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function AppProviders({ children }) {
  return (
    <AppPreferencesProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OrganizationProvider>{children}</OrganizationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </AppPreferencesProvider>
  );
}
